<template>
  <!-- 睡眠検査機器配送ｻｰﾋﾞｽ受付 -->
  <div id="HSTRequestAccept">
    <div id="container">
      <hstNavi v-bind:pageid='"HSTRequestAccept"'></hstNavi>
      <div class="labelTitle lable">睡眠検査機器配送ｻｰﾋﾞｽ 受付</div>
      <!--検索条件 -->
      <div class="condition-area">
        <table class="conditionTable">
          <tr>
            <th>申込日</th>
            <td colspan="3"><input type="date" id="applicationDateStart" v-model="searchConditions.applicationDateStart"/> ～ <input type="date" id="applicationDateEnd" v-model="searchConditions.applicationDateEnd"/></td>
            <th>出荷日</th>
            <td colspan="3"><input type="date" id="shippingDateStart" v-model="searchConditions.shippingDateStart"/> ～ <input type="date" id="shippingDateEnd" v-model="searchConditions.shippingDateEnd"/></td>
          </tr>
          <tr>
            <th>受付番号</th>
            <td><input type="text" id="receiptNumber" v-model="searchConditions.receiptNumber"/></td>
            <th>患者名</th>
            <td><input type="text" id="patientName" v-model="searchConditions.patientName"/></td>
            <th>依頼元</th>
            <td><input type="text" id="client" v-model="searchConditions.client"/></td>
            <th>医療機関</th>
            <td><input type="text" id="hospital" v-model="searchConditions.hospital"/></td>
          </tr>
          <tr>
            <th>機種</th>
            <td><select id="instrumentKind" v-model="searchConditions.model"><option v-for="model in modelList" :value="model.value" :key="model.value">{{ model.label1 }}</option></select></td>
            <th style="font-size: 10px">いびきセンサー</th>
            <td>
              <select id="snoreSensor" v-model="searchConditions.snoreSensor">
                <option></option>
                <option value="1">無</option>
                <option value="2">有</option>
              </select>
            </td>
          </tr>
        </table>
        <div class="searchButton-area">
          <b-button class="is-primary" @click="doSearch">検索</b-button>
        </div>
      </div>
      <!-- 検索結果 -->
      <div class="operation-area">
        <b-button class="operationButton is-primary" icon-left="stamper" :disabled="!checkedRows.length" @click="reception">受付</b-button>
      </div>
      <div class="result-area" v-if="hasResult">
        <b-table
            id="hstRequestAcceptTable"
            :data="data"
            :paginated="isPaginated"
            checkable
            :checked-rows.sync="checkedRows"
            per-page="100"
            pagination-position="both"
            default-sort="user.first_name"
            aria-next-label="Next page"
            aria-previous-label="Previous page"
            aria-page-label="Page"
            aria-current-label="Current page">
            <template slot-scope="props">
              <b-table-column field="hstRequestFlag" label="ePatch同梱の有無" width="120" sortable centered>
                <span v-if="props.row.holterRequestId">有</span><span v-else>無</span>
              </b-table-column>
              <b-table-column field="receiptNumber" label="受付番号" width="150" sortable centered>
                <router-link :to="{name:'HSTRequestAcceptDetail', params:{receiptNumber:props.row.receiptNumber, searchConditions:searchConditions}}"><a>{{props.row.receiptNumber}}</a></router-link>
              </b-table-column>
              <b-table-column field="applicationDate" label="申込日" width="150" sortable centered>
                {{props.row.applicationDate }}
              </b-table-column>
              <b-table-column field="shippingDate" label="出荷日" width="100" sortable centered>
                {{props.row.shippingDate }}
              </b-table-column>
              <b-table-column field="instrumentKind" label="機種" width="200" sortable >
                {{props.row.instrumentKind}}
              </b-table-column>
              <b-table-column field="snoreSensor" label="いびきセンサー" width="100" sortable >
                {{props.row.snoreSensor | snoreSensorFilter()}}
              </b-table-column>
              <b-table-column field="client" label="依頼元" width="250" sortable >
                {{props.row.client}}
              </b-table-column>
              <b-table-column field="hospital" label="医療機関" width="250" sortable >
                {{props.row.hospital}}
              </b-table-column>
              <b-table-column field="patientName" label="患者名" width="180" sortable >
                {{props.row.patientName}}
              </b-table-column>
            </template>
        </b-table>
      </div>
    </div>
  </div>
</template>

<script>
import naviBar from "@/components/mock/philips/hst/HSTNaviBar";
import {choicesType} from "@/components/mock/base/const.js";
export default {
  name: "HSTRequestAccept",
  methods: {
    doSearch: function() {
      var isSearchParam = false
      var keys = Object.keys(this.searchConditions)
      for(var i=0; i < keys.length; i++){
        if(this.searchConditions[keys[i]]){
          isSearchParam = true
          break;
        }
      }
      if(!isSearchParam){
        // 検索条件が１つも設定されていない場合
        this.showErrorMessage("検索条件が入力されていません。")
        return;
      }
      this.data = []
      this.checkedRows = []
      this.hasResult = false;
      var excuteApi = this.getHstRequestListPOST;
      var successCallBack = this.getHstRequestListPOSTSuccess;
      var errorCallBack = this.getHstRequestListPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getHstRequestListPOST: function(client) {
      var obj = JSON.parse(JSON.stringify(this.searchConditions));
      return client.apis.internalHst.getHstRequestListPOST({
        body:obj
      });
    },
    getHstRequestListPOSTSuccess: function(result) {
      // 検索結果取得
      this.data = result.obj
      this.hasResult = true;
    },
    getHstRequestListPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    reception: function() {
      var excuteApi = this.setHstRequestPOST;
      var successCallBack = this.setHstRequestPOSTSuccess;
      var errorCallBack = this.setHstRequestPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    setHstRequestPOST: function(client) {
      var obj = this.checkedRows
      return client.apis.internalHst.setHstRequestPOST({
        body:obj
      });
    },
    setHstRequestPOSTSuccess: function(result) {
      // 検索結果取得
      this.showSuccess(result)
      this.doSearch()
    },
    setHstRequestPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    getChoicesList: async function() {
      this.modelList = this.getChoiceList(this.choicesType.hstKind, false);
      this.modelList.unshift({})
    }
  },
  data() {
    var takeOverSearchParams = this.$route.params["searchConditions"];
    return {
      searchConditions:{
        receiptNumber:"",
        model:"",
        client:"",
        hospital:"",
        patientName:"",
        applicationDateStart:"",
        applicationDateEnd:"",
        shippingDateStart:"",
        shippingDateEnd:"",
        snoreSensor:"",
      },
      choicesType:choicesType,
      data : [],
      checkedRows:[],
      isPaginated : true,
      hasResult:false,
      takeOverSearchParams,
      modelList:[]
    };
  },
  async mounted() {
    // 選択肢マスタ取得
    await this.getChoicesList();
    if(this.takeOverSearchParams){
      this.searchConditions = this.takeOverSearchParams
      this.doSearch()
    }
  },
  filters: {
    snoreSensorFilter(value){
      if (value == "1") {
        return "無"
      } else if (value == "2") {
        return "有"
      } else {
        return "-"
      }
    },
  },
  components: {
    hstNavi: naviBar
  },
};
</script>
<style lang="scss" scoped>
a {
  text-decoration: underline;
}
input {
  width: 200px;
}
.tag {
  width :100px;
}

</style>


// WEBPACK FOOTER //
// src/components/mock/philips/hst/HSTRequestAccept.vue